import React from 'react';
import { CreateOrderContainer } from '../../components/orderCreation/CreateOrderContainer';
import { useDocumentTitleEffect } from '../../utilities/hooks/useDocumentTitleEffect';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';

export const CreateOrderPage: React.FC = () => {
  const userType = useGetUserType();

  const createOrderTitle = userType === eAccessControlUserType.Admin ? 'Create Order' : `${userType} Portal`;
  useDocumentTitleEffect(createOrderTitle);

  return <CreateOrderContainer />;
};
